import { Component } from '@angular/core';

@Component({
  selector: 'app-datenschutz',
  templateUrl: './datenschutz.component.html',
  styleUrls: ['./datenschutz.component.css']
})
export class DatenschutzComponent {
  ngOnInit(): void {
    window.scrollTo(0, 0);
  }
}
